var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99902 18H13.999M6.99902 14H7.99902M6.99902 10H9.99902M6.99902 2H16.499L20.999 6.5V19M13.999 5V8.4C13.999 8.55913 14.0622 8.71174 14.1748 8.82426C14.2873 8.93679 14.4399 9 14.599 9H17.999M2.99902 20.5V6.5C2.99902 6.10218 3.15706 5.72064 3.43836 5.43934C3.71967 5.15804 4.1012 5 4.49902 5H14.251C14.4101 5.00014 14.5626 5.06345 14.675 5.176L17.823 8.324C17.879 8.3799 17.9234 8.44632 17.9536 8.51943C17.9838 8.59254 17.9992 8.6709 17.999 8.75V20.5C17.999 20.8978 17.841 21.2794 17.5597 21.5607C17.2784 21.842 16.8968 22 16.499 22H4.49902C4.1012 22 3.71967 21.842 3.43836 21.5607C3.15706 21.2794 2.99902 20.8978 2.99902 20.5Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.e1925e89f429b0e6941842d0aeb0dcb1.svg";
export { ForwardRef as ReactComponent };